import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { useHasUnreadInbox } from "@hooks/inbox/useInbox";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";
import { router } from "expo-router";
import React from "react";

const ACTIVE_COLOR = "#E6765A";

const InboxButton = () => {
  const hasUnreadInbox = useHasUnreadInbox();
  const isInboxActive = useNavigationStore((state) => state.isInboxPath);

  const iconName = hasUnreadInbox ? "inbox_unread" : "inbox";
  const activeColor = isInboxActive ? ACTIVE_COLOR : undefined;

  return (
    <LPressable
      accessibilityHint="Opens your activity inbox"
      accessibilityLabel="Activity inbox"
      accessibilityRole="button"
      fadeEnabled
      onPress={() => {
        router.navigate(`/(app)/(tabs)/inbox`);
      }}
      sentryEventName="activity_open"
      style={{
        alignItems: "center",
        height: 48,
        justifyContent: "center",
        width: 48,
      }}
      testID="activity-button"
    >
      {iconName === "inbox_unread" ? (
        <LIcon
          colors={activeColor ? { stroke: activeColor } : undefined}
          name="inbox_unread"
          size={26}
        />
      ) : (
        <LIcon
          colors={{ color: activeColor ?? "white" }}
          name="inbox"
          size={26}
        />
      )}
    </LPressable>
  );
};

export default InboxButton;
